import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  right?: ReactNode;
}

export function PageHeader({ title, subtitle, right }: Props) {
  return (
    <header className="flex items-start justify-between mb-[22px] gap-4">
      <div className="min-w-0">
        <h1 className="font-serif text-[28px] font-normal text-fh-ink leading-tight mb-1">
          {title}
        </h1>
        {subtitle && <p className="text-[14px] text-fh-gray m-0">{subtitle}</p>}
      </div>
      {right}
    </header>
  );
}
